import React from 'react';
import './StyleButton.css';

class StyleButton extends React.Component {

  render() {
    const { active, label, onToggle, style } = this.props;

    let className = 'RichEditor-styleButton';
    if (active) {
      className += ' RichEditor-activeButton';
    }

    return (
      <span className={className} onMouseDown={() => onToggle(style)}>
        {label}
      </span>
    );
  }
}

export default StyleButton;
